import { makeStyles } from 'tss-react/mui';

import { SIDEBAR_WIDTH } from '../SideBar';

export interface UseHeaderStylesProps {
  topBannersHeight: number;
}

export const HEADER_HEIGHT = 64;

const name = 'Header';

export const useHeaderStyles = makeStyles<UseHeaderStylesProps>({ name })(
  (theme, { topBannersHeight }) => ({
    root: {
      position: 'fixed',
      top: topBannersHeight,
      zIndex: 1,

      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',

      width: `calc(100% - ${SIDEBAR_WIDTH}px)`,
      height: HEADER_HEIGHT,
      padding: theme.spacing(0, 8),

      color: theme.palette.text.primary,

      [theme.breakpoints.down('xl')]: {
        padding: theme.spacing(0, 5),
      },

      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(0, 7),
      },
    },
    right: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    left: {
      marginRight: 'auto',
    },
    buttons: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(3),

      marginLeft: theme.spacing(2),
    },
  }),
);
